import { Platform, StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'

export const headerStyles = StyleSheet.create({
	row: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		flex: 1,
		justifyContent: 'space-between',
		marginVertical: 5
	},
	arrow: {
		color: colorList.ORANGE.primary,
		fontSize: 18
	},
	arrowDisabled:{
		color: colorList.GREY.primary
	},
	arrowLeft: {
		alignSelf: 'flex-start',
		marginLeft: 2
	},
	arrowRight: {
		alignSelf: 'flex-end',
		marginRight: 2
	},
	title: {
		color: colorList.BLACK.light,
		fontSize: 16,
		textAlign: 'center'
	}
});

export const calendarStyles = StyleSheet.create( {
	row: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		flex: 1,
		justifyContent: 'space-between',
		marginVertical: 5,
	},
	col: {
		width: '14%',
		alignItems: 'center',
		alignSelf: 'flex-start',
	},
	day: {
		width: 30,
		height: 30,
		//lineHeight: 30,
		borderRadius: 15,
		textAlign: 'center',
		textAlignVertical: 'center',
		justifyContent: 'center',
		alignItems: 'center',
	},
	day_active: {
		backgroundColor: colorList.ORANGE.primary,
	},
	day_text:{
		fontSize: 14,
		textAlign: 'center',
		textAlignVertical: 'center',
		...Platform.select({
			ios: {
				lineHeight: 29 // as same as height
			},
			web: {
				lineHeight: 29 // as same as height
			},
			android: {
				lineHeight: 29 // as same as height
			}
		}),
		color: colorList.BLACK.primary
	},
	day_text_active: {
		color: colorList.WHITE.primary
	},
	day_text_inactive: {
		color: colorList.GREY.dark
	},
	day_text_today: {
		color: colorList.ORANGE.primary
	},
	
	dots: {
		height: 6,
		width: 30,
		marginTop: 2,
		flexDirection: 'row',
		flexWrap: 'wrap',
		flex: 1,
		justifyContent: 'center',
		
	},
	dot: {
		width: 5,
		height: 5,
		marginLeft: 1,
		marginRight: 1,
		borderRadius: 5,
	},
	dotSpacer: {
		width: '100%',
		height: 1
	}
});

export const calendarHeaderStyles = StyleSheet.create( {
	day_text: {
		fontSize: 12,
		padding: 5,
		textAlign: 'center',
		color: colorList.BLACK.light,
	}
});

export const footerStyles = StyleSheet.create( {
	row: {
		alignItems: 'flex-end'
	},
	text:{
		alignSelf: 'flex-end',
		fontSize: 12,
		color: colorList.ORANGE.primary,
		textDecorationLine: 'underline'
	}
});
